<template>
    <div class="wrap">
        <listHeader
            :title="postData.jid > 0 ? '编辑职位' : '新增职位'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="job"
                active="info"
                :jid="postData.jid"
            ></hro-tab>

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="职位类型"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-select
                                    v-decorator="['type', {required: true, rules: [{ message: '选择职位类型' }], initialValue: ''}]">>
                                    <a-select-option value="">选择职位类型</a-select-option>
                                    <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">
                                        {{ item }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="职位名称"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入职位名称" v-decorator="['jobname', {rules: [{ required: true, max: 32, message: '请输入职位名称' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="退休年龄（男）"
                                v-bind="formItemLayout"
                            >
                                <a-input placeholder="请输入退休年龄（男）" v-decorator="['mretire', {rules: [{ required: false, message: '请输入退休年龄（男）' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="退休年龄（女）"
                                v-bind="formItemLayout"
                            >
                                <a-input placeholder="请输入退休年龄（女）" v-decorator="['feretire', {rules: [{ required: false, message: '请输入退休年龄（女）' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import hroTab from '@/components/list/tab';

export default {
    components: {
        listHeader,
        hroTab,
    },
    data() {
        return {
            scenario: 'jobCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'eid': '',
                'jid': '',
            },
            data: {},
            config: {},
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/job/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.jid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            type: res.data.type,
                            jobname: res.data.jobname,
                            mretire: res.data.mretire,
                            feretire: res.data.feretire,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.jid > 0) {
                            url = '/manage/job/edit';

                            values.jid = this.postData.jid;
                        } else {
                            url = '/manage/job/save';

                            values.eid = this.postData.eid;
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                if (this.postData.jid == '') {
                                    this.$router.go(-1);
                                } else {
                                    this.getData();
                                }
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
